import {fetchScheduleFromDatabase} from "./databasehandler";
import Schedule from "../models/Schedule";

export const getSchedule = async (eventId) => {
    const result = await fetchScheduleFromDatabase(eventId);

    if (!result || result.length === 0) {
        return null;
    }

    return result.map((schedule) => new Schedule(schedule));
}

export const isScheduleItemFinished = (scheduleItem) => {
    return Boolean(
        scheduleItem.results &&
        Array.isArray(scheduleItem.results) &&
        scheduleItem.results.length > 0 &&
        scheduleItem.results.filter((r) => r.start_nr !== null && r.start_nr !== undefined && r.start_nr !== "").length >= scheduleItem.results.length
    );
}